import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Detailed Expired Cards Report"
  reportDownloadName = "expiredCardsReport"
  apiReportName = "breakageReport"
  downloadOnly = {true}
/>
